var _module_exports = "<div> <iframe class=\"ifrmDirectAlert\" style=\"width:100%;height:650px\" ng-src=\"{{$ctrl.iframeUrl}}\"></iframe> </div> ";;
var path = '/app/components/search/search-directalert.component.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;